// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gs-groups-section {
  padding: 0;
  background: transparent;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: hidden;
  height: auto;
  min-height: auto
}

.gs-groups-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
  max-width: 100%;
}

.gs-view-tabs {
  display: flex;
  background: white;
  border-radius: 8px;
  padding: 4px;
  border: 1px solid #e2e8f0;
  flex-wrap: wrap;
  gap: 2px;
  flex: 1 1;
  min-width: 0;
  max-width: 100%;
}

.gs-view-tab {
  padding: 8px 12px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  transition: all 0.3s ease;
  flex: 1 1;
  min-width: 0;
  text-align: center;
  white-space: nowrap;
}

.gs-view-tab.gs-active {
  background: #002FA7;
  color: white;
}

.gs-view-tab:hover:not(.gs-active) {
  background: #e2e8f0;
  color: #002FA7;
}

.gs-groups-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;
  max-width: 100%;
  overflow-x: hidden;
}

/* Строка с контролами */
.gs-controls-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
}

/* Стили для вкладки "По семестрам" */
.gs-semester-controls {
  display: flex;
  flex: 1 1;
  min-width: 300px;
}

.gs-semester-tabs {
  display: flex;
  background: #f8fafc;
  border-radius: 8px;
  padding: 4px;
  border: 1px solid #e2e8f0;
  flex-wrap: wrap;
  gap: 2px;
  min-width: 0;
  width: 100%;
}

.gs-semester-tab {
  padding: 8px 12px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  transition: all 0.3s ease;
  flex: 1 1;
  min-width: 0;
  text-align: center;
  white-space: nowrap;
}

.gs-semester-tab.gs-active {
  background: #002FA7;
  color: white;
}

.gs-semester-tab:hover:not(.gs-active) {
  background: #e2e8f0;
  color: #002FA7;
}

/* Стили для вкладки "По курсу" */
.gs-course-controls {
  display: flex;
  flex: 1 1;
  min-width: 300px;
}

.gs-course-tabs {
  display: flex;
  background: #f8fafc;
  border-radius: 8px;
  padding: 4px;
  border: 1px solid #e2e8f0;
  flex-wrap: wrap;
  gap: 2px;
  min-width: 0;
  width: 100%;
}

.gs-course-tab {
  padding: 8px 12px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  transition: all 0.3s ease;
  flex: 1 1;
  min-width: 0;
  text-align: center;
  white-space: nowrap;
}

.gs-course-tab.gs-active {
  background: #002FA7;
  color: white;
}

.gs-course-tab:hover:not(.gs-active) {
  background: #e2e8f0;
  color: #002FA7;
}

.gs-groups-table-container {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.gs-groups-table {
  width: auto;
  min-width: 100%;
  border-collapse: collapse;
  background: white;
  table-layout: fixed;
}

.gs-groups-table th {
  background: #f8fafc;
  color: #002c9c;
  font-size: 14px;
  font-weight: 500;
  padding: 16px 8px;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
  min-width: 20px;
  height: 60px;
  vertical-align: middle;
}

/* Центрирование конкретных заголовков */
.gs-number-column,
.gs-group-column {
  text-align: center;
}

/* Левые заголовки */
.gs-specialty-column,
.gs-subject-column {
  text-align: left;
}

/* Центрированные заголовки для многострочных */
.gs-students-column,
.gs-attendance-column {
  text-align: center;
}

.gs-groups-table td {
  padding: 16px 8px;
  border-bottom: 1px solid #f1f5f9;
  color: #1e293b;
  font-size: 14px;
  transition: all 0.3s ease;
  min-width: 40px;
  word-break: break-word;
  vertical-align: middle;
}

/* Стили для заголовков с переносами */
.gs-header-text {
  text-align: center;
  line-height: 1.2;
  white-space: normal;
  word-break: break-word;
}

/* Стили для колонок таблицы */
.gs-number-column {
  width: 50px;
  min-width: 50px;
  max-width: 50px;
}

.gs-group-column {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
}

.gs-specialty-column {
  min-width: 180px;
  max-width: 180px;
}

.gs-subject-column {
  min-width: 180px;
}

.gs-students-column {
  width: 120px;
  min-width: 120px;
  max-width: 120px;
}

.gs-attendance-column {
  width: 140px;
  min-width: 140px;
  max-width: 140px;
}

/* Выравнивание ячеек */
.gs-number-cell {
  text-align: center;
  color: #64748b;
  font-weight: 500;
}

.gs-group-name {
  color: #002FA7;
  font-weight: 500;
  text-align: center;
}

.gs-specialty-cell {
  color: #1e293b;
  font-weight: 500;
  text-align: left;
}

.gs-subject-cell {
  color: #1e293b;
  font-weight: 500;
  text-align: left;
}

.gs-students-cell {
  text-align: center;
  color: #1e293b;
  font-weight: 500;
}

.gs-attendance-percent {
  text-align: center;
}

.gs-percent-bubble {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 70px;
  height: 32px;
  padding: 0 12px;
  color: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: default;
}

.gs-column-header {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
}

.gs-sort-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.gs-sort-button:hover {
  background-color: #e2e8f0;
}

.gs-sort-icon {
  width: 16px;
  height: 16px;
  transition: transform 0.2s ease;
}

.gs-sort-desc {
  transform: rotate(180deg);
}

/* Кнопки действий */
.gs-action-buttons {
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.gs-attendance-btn,
.gs-grades-btn {
  color: white;
  border: none;
  padding: 13px 25px;
  border-radius: 13px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Стиль для выбранной строки */
.gs-group-row.gs-selected {
  background-color: #f0f7ff;
  border-left: 3px solid #002FA7;
}

.gs-group-row {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.gs-group-row:hover {
  background-color: #f8fafc;
}

/* АКТИВНЫЕ кнопки (когда группа выбрана) */
.gs-attendance-btn:not(.gs-disabled),
.gs-grades-btn:not(.gs-disabled) {
  background: #002FA7;
  padding: 13px 25px;
  border-radius: 13px;
  color: white;
  border: none;
}

.gs-attendance-btn:not(.gs-disabled):hover,
.gs-grades-btn:not(.gs-disabled):hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);
}

/* Стили для отключенных кнопок */
.gs-attendance-btn.gs-disabled,
.gs-grades-btn.gs-disabled {
  background: #cbd5e186;
  border-color: #94a3b898;
  color: #656565;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.gs-attendance-btn.gs-disabled:hover,
.gs-grades-btn.gs-disabled:hover {
  transform: none;
  box-shadow: none;
}

/* Стили для блока фильтра по дисциплине */
.gs-discipline-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
  margin-bottom: 24px;
}

.gs-discipline-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}

.gs-discipline-name {
  font-size: 18px;
  color: #002FA7;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.8);
  padding: 8px 16px;
  border-radius: 8px;
  border-left: 4px solid #002FA7;
}

/* Кнопка сброса фильтра */
.gs-clear-discipline {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 2px solid #e2e8f0;
  color: #374151;
  padding: 12px 24px;
  border-radius: 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  max-width: 200px;
  min-width: 200px;
  justify-content: center;
}

.gs-clear-discipline:hover {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
  color: #002FA7;
}

.gs-clear-discipline:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* Стили для заголовка групп */
.gs-cabinet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 16px;
}

.gs-error-message {
  background: #fed7d7;
  color: #c53030;
  padding: 12px 16px;
  border-radius: 8px;
  margin: 16px 0;
  border-left: 4px solid #c53030;
  text-align: center;
}

/* Стили для поиска по группе */
.gs-group-search {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  position: relative;
}

.gs-group-search-input {
  padding: 12px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  font-size: 14px;
  font-weight: 500;
  min-width: 214px;
  transition: all 0.3s ease;
}

.gs-group-search-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.gs-group-search-input::placeholder {
  color: #64748b;
}

.pc-refresh-btn.pc-refreshing {
  opacity: 0.7;
  cursor: not-allowed;
}

.pc-refresh-spin {
  animation: pc-spin 1s linear infinite;
}

.gs-clear-search {
  position: absolute;
  right: 8px;
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  font-size: 18px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.gs-clear-search:hover {
  background: #f1f5f9;
  color: #374151;
}

@keyframes pc-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Адаптивность для поиска */
@media (max-width: 1024px) {
  .gs-group-search-input {
    min-width: 180px;
    font-size: 13px;
    padding: 7px 10px;
  }
}

@media (max-width: 768px) {
  .gs-group-search {
    width: 100%;
    justify-content: space-between;
  }
  
  .gs-group-search-input {
    min-width: 0;
    width: 100%;
    font-size: 12px;
    padding: 6px 8px;
  }
}

@media (max-width: 480px) {
  .gs-group-search-input {
    font-size: 11px;
    padding: 5px 6px;
  }
}

/* Обновленные медиа-запросы для строки контролов */
@media (max-width: 768px) {
  .gs-controls-row {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .gs-semester-controls,
  .gs-course-controls,
  .gs-group-search {
    min-width: 100%;
  }
  
  .gs-group-search {
    order: 3;
  }
}

/* Адаптивность для планшетов (768px - 1024px) */
@media (max-width: 1024px) {
  .gs-groups-table th,
  .gs-groups-table td {
    padding: 12px 6px;
    font-size: 13px;
  }
  
  .gs-view-tab,
  .gs-semester-tab,
  .gs-course-tab {
    padding: 6px 8px;
    font-size: 13px;
  }
  
  .gs-percent-bubble {
    min-width: 60px;
    height: 28px;
    font-size: 12px;
  }

  .gs-groups-table th {
    height: 50px;
    font-size: 12px;
  }

  .gs-controls-row {
    gap: 15px;
  }
}

/* Адаптивность для мобильных устройств (768px и меньше) */
@media (max-width: 768px) {
  .gs-groups-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .gs-view-tabs {
    width: 100%;
  }
  
  .gs-view-tab {
    padding: 6px 8px;
    font-size: 12px;
    min-width: 0;
  }
  
  .gs-controls-row {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .gs-semester-controls,
  .gs-course-controls {
    min-width: 100%;
  }
  
  .gs-groups-table th,
  .gs-groups-table td {
    padding: 10px 4px;
    font-size: 12px;
  }
  
  .gs-semester-tabs,
  .gs-course-tabs {
    width: 100%;
  }
  
  .gs-semester-tab,
  .gs-course-tab {
    padding: 6px 8px;
    font-size: 12px;
    min-width: 0;
  }
  
  .gs-percent-bubble {
    min-width: 50px;
    height: 24px;
    font-size: 11px;
    padding: 0 8px;
  }

  .gs-groups-table th {
    height: 45px;
    font-size: 11px;
  }

  .gs-action-buttons {
    justify-content: center;
  }
  
  .gs-attendance-btn,
  .gs-grades-btn {
    padding: 10px 20px;
    font-size: 13px;
    flex: 1 1;
    min-width: 140px;
  }
}

/* Адаптивность для маленьких мобильных устройств (480px и меньше) */
@media (max-width: 480px) {
  .gs-groups-table th,
  .gs-groups-table td {
    padding: 8px 3px;
    font-size: 10px;
  }

  .gs-view-tab {
    padding: 5px 6px;
    font-size: 10px;
  }
  
  .gs-semester-tab,
  .gs-course-tab {
    padding: 5px 6px;
    font-size: 10px;
  }
  
  .gs-percent-bubble {
    min-width: 40px;
    height: 20px;
    font-size: 9px;
    padding: 0 6px;
    border-radius: 4px;
  }

  .gs-groups-table th {
    height: 40px;
    font-size: 9px;
  }

  .gs-header-text {
    line-height: 1.1;
  }

  .gs-action-buttons {
    flex-direction: column;
    gap: 10px;
  }
  
  .gs-attendance-btn,
  .gs-grades-btn {
    width: 100%;
    padding: 12px 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/th-components/GroupsSectionStyle.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;;EAEE,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;;EAEE,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;;EAEE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,iCAAiC;AACjC;;EAEE,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,4BAA4B;AAC5B;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA,gDAAgD;AAChD;EACE;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;;IAGE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,0DAA0D;AAC1D;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;IACf,SAAO;IACP,gBAAgB;EAClB;AACF;;AAEA,oEAAoE;AACpE;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,cAAc;IACd,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":[".gs-groups-section {\n  padding: 0;\n  background: transparent;\n  width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  height: auto;\n  min-height: auto\n}\n\n.gs-groups-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  gap: 16px;\n  flex-wrap: wrap;\n  width: 100%;\n  box-sizing: border-box;\n  max-width: 100%;\n}\n\n.gs-view-tabs {\n  display: flex;\n  background: white;\n  border-radius: 8px;\n  padding: 4px;\n  border: 1px solid #e2e8f0;\n  flex-wrap: wrap;\n  gap: 2px;\n  flex: 1;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.gs-view-tab {\n  padding: 8px 12px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  transition: all 0.3s ease;\n  flex: 1;\n  min-width: 0;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.gs-view-tab.gs-active {\n  background: #002FA7;\n  color: white;\n}\n\n.gs-view-tab:hover:not(.gs-active) {\n  background: #e2e8f0;\n  color: #002FA7;\n}\n\n.gs-groups-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  box-sizing: border-box;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n/* Строка с контролами */\n.gs-controls-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n/* Стили для вкладки \"По семестрам\" */\n.gs-semester-controls {\n  display: flex;\n  flex: 1;\n  min-width: 300px;\n}\n\n.gs-semester-tabs {\n  display: flex;\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 4px;\n  border: 1px solid #e2e8f0;\n  flex-wrap: wrap;\n  gap: 2px;\n  min-width: 0;\n  width: 100%;\n}\n\n.gs-semester-tab {\n  padding: 8px 12px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  transition: all 0.3s ease;\n  flex: 1;\n  min-width: 0;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.gs-semester-tab.gs-active {\n  background: #002FA7;\n  color: white;\n}\n\n.gs-semester-tab:hover:not(.gs-active) {\n  background: #e2e8f0;\n  color: #002FA7;\n}\n\n/* Стили для вкладки \"По курсу\" */\n.gs-course-controls {\n  display: flex;\n  flex: 1;\n  min-width: 300px;\n}\n\n.gs-course-tabs {\n  display: flex;\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 4px;\n  border: 1px solid #e2e8f0;\n  flex-wrap: wrap;\n  gap: 2px;\n  min-width: 0;\n  width: 100%;\n}\n\n.gs-course-tab {\n  padding: 8px 12px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  transition: all 0.3s ease;\n  flex: 1;\n  min-width: 0;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.gs-course-tab.gs-active {\n  background: #002FA7;\n  color: white;\n}\n\n.gs-course-tab:hover:not(.gs-active) {\n  background: #e2e8f0;\n  color: #002FA7;\n}\n\n.gs-groups-table-container {\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.gs-groups-table {\n  width: auto;\n  min-width: 100%;\n  border-collapse: collapse;\n  background: white;\n  table-layout: fixed;\n}\n\n.gs-groups-table th {\n  background: #f8fafc;\n  color: #002c9c;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 16px 8px;\n  border-bottom: 1px solid #e2e8f0;\n  white-space: nowrap;\n  min-width: 20px;\n  height: 60px;\n  vertical-align: middle;\n}\n\n/* Центрирование конкретных заголовков */\n.gs-number-column,\n.gs-group-column {\n  text-align: center;\n}\n\n/* Левые заголовки */\n.gs-specialty-column,\n.gs-subject-column {\n  text-align: left;\n}\n\n/* Центрированные заголовки для многострочных */\n.gs-students-column,\n.gs-attendance-column {\n  text-align: center;\n}\n\n.gs-groups-table td {\n  padding: 16px 8px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #1e293b;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  min-width: 40px;\n  word-break: break-word;\n  vertical-align: middle;\n}\n\n/* Стили для заголовков с переносами */\n.gs-header-text {\n  text-align: center;\n  line-height: 1.2;\n  white-space: normal;\n  word-break: break-word;\n}\n\n/* Стили для колонок таблицы */\n.gs-number-column {\n  width: 50px;\n  min-width: 50px;\n  max-width: 50px;\n}\n\n.gs-group-column {\n  width: 80px;\n  min-width: 80px;\n  max-width: 80px;\n}\n\n.gs-specialty-column {\n  min-width: 180px;\n  max-width: 180px;\n}\n\n.gs-subject-column {\n  min-width: 180px;\n}\n\n.gs-students-column {\n  width: 120px;\n  min-width: 120px;\n  max-width: 120px;\n}\n\n.gs-attendance-column {\n  width: 140px;\n  min-width: 140px;\n  max-width: 140px;\n}\n\n/* Выравнивание ячеек */\n.gs-number-cell {\n  text-align: center;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.gs-group-name {\n  color: #002FA7;\n  font-weight: 500;\n  text-align: center;\n}\n\n.gs-specialty-cell {\n  color: #1e293b;\n  font-weight: 500;\n  text-align: left;\n}\n\n.gs-subject-cell {\n  color: #1e293b;\n  font-weight: 500;\n  text-align: left;\n}\n\n.gs-students-cell {\n  text-align: center;\n  color: #1e293b;\n  font-weight: 500;\n}\n\n.gs-attendance-percent {\n  text-align: center;\n}\n\n.gs-percent-bubble {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 70px;\n  height: 32px;\n  padding: 0 12px;\n  color: white;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: default;\n}\n\n.gs-column-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: flex-start;\n}\n\n.gs-sort-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n.gs-sort-button:hover {\n  background-color: #e2e8f0;\n}\n\n.gs-sort-icon {\n  width: 16px;\n  height: 16px;\n  transition: transform 0.2s ease;\n}\n\n.gs-sort-desc {\n  transform: rotate(180deg);\n}\n\n/* Кнопки действий */\n.gs-action-buttons {\n  display: flex;\n  gap: 16px;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n\n.gs-attendance-btn,\n.gs-grades-btn {\n  color: white;\n  border: none;\n  padding: 13px 25px;\n  border-radius: 13px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* Стиль для выбранной строки */\n.gs-group-row.gs-selected {\n  background-color: #f0f7ff;\n  border-left: 3px solid #002FA7;\n}\n\n.gs-group-row {\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.gs-group-row:hover {\n  background-color: #f8fafc;\n}\n\n/* АКТИВНЫЕ кнопки (когда группа выбрана) */\n.gs-attendance-btn:not(.gs-disabled),\n.gs-grades-btn:not(.gs-disabled) {\n  background: #002FA7;\n  padding: 13px 25px;\n  border-radius: 13px;\n  color: white;\n  border: none;\n}\n\n.gs-attendance-btn:not(.gs-disabled):hover,\n.gs-grades-btn:not(.gs-disabled):hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);\n}\n\n/* Стили для отключенных кнопок */\n.gs-attendance-btn.gs-disabled,\n.gs-grades-btn.gs-disabled {\n  background: #cbd5e186;\n  border-color: #94a3b898;\n  color: #656565;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.gs-attendance-btn.gs-disabled:hover,\n.gs-grades-btn.gs-disabled:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n/* Стили для блока фильтра по дисциплине */\n.gs-discipline-filter {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px;\n  margin-bottom: 24px;\n}\n\n.gs-discipline-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n}\n\n.gs-discipline-name {\n  font-size: 18px;\n  color: #002FA7;\n  font-weight: 600;\n  background: rgba(255, 255, 255, 0.8);\n  padding: 8px 16px;\n  border-radius: 8px;\n  border-left: 4px solid #002FA7;\n}\n\n/* Кнопка сброса фильтра */\n.gs-clear-discipline {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border: 2px solid #e2e8f0;\n  color: #374151;\n  padding: 12px 24px;\n  border-radius: 16px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  white-space: nowrap;\n  max-width: 200px;\n  min-width: 200px;\n  justify-content: center;\n}\n\n.gs-clear-discipline:hover {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-color: #cbd5e1;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);\n  color: #002FA7;\n}\n\n.gs-clear-discipline:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n/* Стили для заголовка групп */\n.gs-cabinet-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 16px;\n}\n\n.gs-error-message {\n  background: #fed7d7;\n  color: #c53030;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin: 16px 0;\n  border-left: 4px solid #c53030;\n  text-align: center;\n}\n\n/* Стили для поиска по группе */\n.gs-group-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.gs-group-search-input {\n  padding: 12px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: white;\n  font-size: 14px;\n  font-weight: 500;\n  min-width: 214px;\n  transition: all 0.3s ease;\n}\n\n.gs-group-search-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.gs-group-search-input::placeholder {\n  color: #64748b;\n}\n\n.pc-refresh-btn.pc-refreshing {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.pc-refresh-spin {\n  animation: pc-spin 1s linear infinite;\n}\n\n.gs-clear-search {\n  position: absolute;\n  right: 8px;\n  background: none;\n  border: none;\n  color: #64748b;\n  cursor: pointer;\n  font-size: 18px;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.gs-clear-search:hover {\n  background: #f1f5f9;\n  color: #374151;\n}\n\n@keyframes pc-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Адаптивность для поиска */\n@media (max-width: 1024px) {\n  .gs-group-search-input {\n    min-width: 180px;\n    font-size: 13px;\n    padding: 7px 10px;\n  }\n}\n\n@media (max-width: 768px) {\n  .gs-group-search {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .gs-group-search-input {\n    min-width: 0;\n    width: 100%;\n    font-size: 12px;\n    padding: 6px 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .gs-group-search-input {\n    font-size: 11px;\n    padding: 5px 6px;\n  }\n}\n\n/* Обновленные медиа-запросы для строки контролов */\n@media (max-width: 768px) {\n  .gs-controls-row {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n  \n  .gs-semester-controls,\n  .gs-course-controls,\n  .gs-group-search {\n    min-width: 100%;\n  }\n  \n  .gs-group-search {\n    order: 3;\n  }\n}\n\n/* Адаптивность для планшетов (768px - 1024px) */\n@media (max-width: 1024px) {\n  .gs-groups-table th,\n  .gs-groups-table td {\n    padding: 12px 6px;\n    font-size: 13px;\n  }\n  \n  .gs-view-tab,\n  .gs-semester-tab,\n  .gs-course-tab {\n    padding: 6px 8px;\n    font-size: 13px;\n  }\n  \n  .gs-percent-bubble {\n    min-width: 60px;\n    height: 28px;\n    font-size: 12px;\n  }\n\n  .gs-groups-table th {\n    height: 50px;\n    font-size: 12px;\n  }\n\n  .gs-controls-row {\n    gap: 15px;\n  }\n}\n\n/* Адаптивность для мобильных устройств (768px и меньше) */\n@media (max-width: 768px) {\n  .gs-groups-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n  \n  .gs-view-tabs {\n    width: 100%;\n  }\n  \n  .gs-view-tab {\n    padding: 6px 8px;\n    font-size: 12px;\n    min-width: 0;\n  }\n  \n  .gs-controls-row {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n  \n  .gs-semester-controls,\n  .gs-course-controls {\n    min-width: 100%;\n  }\n  \n  .gs-groups-table th,\n  .gs-groups-table td {\n    padding: 10px 4px;\n    font-size: 12px;\n  }\n  \n  .gs-semester-tabs,\n  .gs-course-tabs {\n    width: 100%;\n  }\n  \n  .gs-semester-tab,\n  .gs-course-tab {\n    padding: 6px 8px;\n    font-size: 12px;\n    min-width: 0;\n  }\n  \n  .gs-percent-bubble {\n    min-width: 50px;\n    height: 24px;\n    font-size: 11px;\n    padding: 0 8px;\n  }\n\n  .gs-groups-table th {\n    height: 45px;\n    font-size: 11px;\n  }\n\n  .gs-action-buttons {\n    justify-content: center;\n  }\n  \n  .gs-attendance-btn,\n  .gs-grades-btn {\n    padding: 10px 20px;\n    font-size: 13px;\n    flex: 1;\n    min-width: 140px;\n  }\n}\n\n/* Адаптивность для маленьких мобильных устройств (480px и меньше) */\n@media (max-width: 480px) {\n  .gs-groups-table th,\n  .gs-groups-table td {\n    padding: 8px 3px;\n    font-size: 10px;\n  }\n\n  .gs-view-tab {\n    padding: 5px 6px;\n    font-size: 10px;\n  }\n  \n  .gs-semester-tab,\n  .gs-course-tab {\n    padding: 5px 6px;\n    font-size: 10px;\n  }\n  \n  .gs-percent-bubble {\n    min-width: 40px;\n    height: 20px;\n    font-size: 9px;\n    padding: 0 6px;\n    border-radius: 4px;\n  }\n\n  .gs-groups-table th {\n    height: 40px;\n    font-size: 9px;\n  }\n\n  .gs-header-text {\n    line-height: 1.1;\n  }\n\n  .gs-action-buttons {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .gs-attendance-btn,\n  .gs-grades-btn {\n    width: 100%;\n    padding: 12px 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
